// extracted by mini-css-extract-plugin
export default {"bentoBoxHomepageContainer":"BentoBoxHomepage_bentoBoxHomepageContainer__X+bYV","defaultTemplate":"BentoBoxHomepage_defaultTemplate__qhXNJ"};